module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0087.jpg?v=ca313e2a";